import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { ContractComparisonModel } from '../../models';
import { InstanceUtils, getVisibleComparisonInputIds } from '../../misc';
import { BasicComparisonRenderer, LayersComparisonRenderer } from '..';
import { useAppStore } from '../../stores';
import './ContractComparisonDetailsRenderer.less';

interface Props {
    contractComparison: ContractComparisonModel;
    isVisible: boolean;
}

const ContractComparisonDetailsRenderer: React.FC<Props> = ({ contractComparison, isVisible }) => {
    const { contractComparisonStore } = useAppStore();

    const getClassName = () => {
        let className = 'contract-comparison-details-renderer';

        if (!isVisible) {
            className += ' hidden';
        }

        if (contractComparison.isExecutingAction) {
            className += ' loading';
        }

        return className;
    };

    const visibleComparisonNodes = contractComparison.comparisonNodes.filter(comparisonNode =>
        comparisonNode.panels.some(panel => {
            const inputGroupChangeTracker = comparisonNode.contractChangeTracker.getInputGroupChangeTracker(panel.id);

            if (!inputGroupChangeTracker) {
                return false;
            }

            return (
                getVisibleComparisonInputIds(
                    contractComparisonStore.selectedFilter,
                    panel.inputIds,
                    inputGroupChangeTracker
                ).length > 0
            );
        })
    );

    const showNoFieldsMessage = contractComparisonStore.selectedFilter !== 'all' && !visibleComparisonNodes.length;

    return (
        <div className={getClassName()}>
            {showNoFieldsMessage && (
                <div className="contract-comparison-details-empty-state">
                    <span>There are no fields matching the current filter.</span>
                </div>
            )}

            {!showNoFieldsMessage && visibleComparisonNodes.map(comparisonNode => {
                if (InstanceUtils.isBasicComparisonNode(comparisonNode)) {
                    return <BasicComparisonRenderer key={comparisonNode.nodeId} comparisonNode={comparisonNode} />;
                }

                if (InstanceUtils.isLayersComparisonNode(comparisonNode)) {
                    return <LayersComparisonRenderer key={comparisonNode.nodeId} comparisonNode={comparisonNode} />;
                }

                return null;
            })}
        </div>
    );
};

export default observer(ContractComparisonDetailsRenderer);
